export default __webpack_public_path__ + "static/media/503.93ad23ad.jpg";